import { render } from "./Stress.vue?vue&type=template&id=072570f3&scoped=true"
import script from "./Stress.vue?vue&type=script&lang=js"
export * from "./Stress.vue?vue&type=script&lang=js"

import "./Stress.vue?vue&type=style&index=0&id=072570f3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-072570f3"],['__file',"src/apps/quiz/routes/Stress.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "072570f3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('072570f3', __exports__)) {
    api.reload('072570f3', __exports__)
  }
  
  module.hot.accept("./Stress.vue?vue&type=template&id=072570f3&scoped=true", () => {
    api.rerender('072570f3', render)
  })

}


export default __exports__